module.exports = __webpack_public_path__ + "static/media/Grupo 300@2x.e0275509.png";